// TODO: Import React module
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

// TODO: Import MUI module
import {
    Alert, Autocomplete, Box, Button, Grid,
    Link, Paper, Snackbar, Stack, TextField, Typography
} from '@mui/material';

// TODO: Import MUI icon
import { ZoomIn } from '@mui/icons-material';

// TODO: Import context
import { Context, Webservices } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import BoxSubPage from '../Common/BoxSubPage';
import { ContentTitle } from '../Common/TypographyTYH';

const InfoDay = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component InfoDay Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const [formValue, setFormValue] = React.useState({
        student: '',
        parent: '',
        school: '',
        attendees: '1',
        phone: '',
        email: '',
        enquiry: '',
    });

    const [schoolList, setSchoolList] = React.useState([]);

    const [validation, setValidation] = React.useState({
        student: true,
        parent: true,
        attendees: true,
        phone: true,
        email: true
    });

    const [formValidated, setFormValidated] = React.useState(false);

    const [disableRegister, setDisableRegister] = React.useState(true);
    const [registered, setRegistered] = React.useState(false);

    const [showSnackbar, setShowSnackbar] = React.useState({ open: false, severity: 'error', message: '' });

    // TODO: Define event
    const navigate = useNavigate();

    React.useEffect(() => { window.scrollTo(0, 0); }, []);

    React.useEffect(() => {
        (async () => {
            const formData = new FormData();
            formData.append('action', 'InfoDay_GetPrimarySchool');

            fetch(Webservices, { method: 'POST', body: formData, })
                .then((response) => response.json())
                .then((result) => {
                    if (result.length > 0) { setSchoolList(result) }
                }).catch((error) => { console.error('Error:', error); });
        })();
    }, []);

    const conditionParent = React.useCallback(() => formValue.parent.length > 0, [formValue.parent.length]);
    const conditionStudent = React.useCallback(() => formValue.student.length > 0, [formValue.student.length]);
    const conditionAttendees = React.useCallback(() => parseInt(formValue.attendees) >= 1 && parseInt(formValue.attendees) <= 3, [formValue.attendees]);
    const conditionPhone = React.useCallback(() => (parseInt(formValue.phone) >= 10000000 && parseInt(formValue.phone) <= 99999999) || formValue.phone.length === 0, [formValue.phone]);
    const conditionEmail = React.useCallback(() => formValue.email.includes('@'), [formValue.email]);

    const handleBlurParent = () => { setValidation(preState => ({ ...preState, parent: conditionParent() })) };
    const handleBlurStudent = () => { setValidation(preState => ({ ...preState, student: conditionStudent() })) };
    const handleBlurAttendees = () => { setValidation(preState => ({ ...preState, attendees: conditionAttendees() })) };
    const handleBlurPhone = () => { setValidation(preState => ({ ...preState, phone: conditionPhone() })) };
    const handleBlurEmail = () => { setValidation(preState => ({ ...preState, email: conditionEmail() })) };

    React.useEffect(() => {
        if (conditionParent() && conditionStudent() && conditionAttendees() && conditionPhone() && conditionEmail()) {
            setDisableRegister(false);
        } else {
            setDisableRegister(true);
        }
    }, [conditionAttendees, conditionEmail, conditionParent, conditionPhone, conditionStudent, validation]);

    const handleClickRegister = () => {
        if (
            formValue.parent.length > 0 &&
            formValue.student.length > 0 &&
            parseInt(formValue.attendees) >= 1 && parseInt(formValue.attendees) <= 3 &&
            ((parseInt(formValue.phone) >= 10000000 && parseInt(formValue.phone) <= 99999999) || formValue.phone.length === 0) &&
            formValue.email.includes('@')
        ) {
            setFormValidated(true);

            (async () => {
                const formData = new FormData();
                formData.append('action', 'InfoDay_Register');
                formData.append('data', JSON.stringify(formValue));

                fetch(Webservices, { method: 'POST', body: formData, })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result === 'SUCCESS') {
                            setRegistered(true);
                            setShowSnackbar(preState => ({
                                ...preState,
                                open: true,
                                severity: 'success',
                                message: Text.InfoDay.Snackbar.Success[context.language]
                            }));
                            setDisableRegister(true);
                            setTimeout(() => navigate('/'), 5000);
                        } else {
                            setShowSnackbar(preState => ({
                                ...preState,
                                open: true,
                                severity: 'error',
                                message: Text.InfoDay.Snackbar.Failure[context.language]
                            }));
                        }
                    }).catch((error) => { console.error('Error:', error); });
            })();
        } else {
            setFormValidated(false);
        }
    };

    // TODO: Return component
    return (
        <BoxSubPage
            id="InfoDay"
            disableMenu={true}
            disableSubtitle={true}
            title={Text.InfoDay.Title[context.language]}
        >
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
                <Typography sx={{ flex: 1, textAlign: 'center' }} variant="body1">
                    感謝各位支持本校12月6日升中資訊日。如仍想報名，請於12月4日或以前致電2246 3221查詢。
                </Typography>
                {/*<Typography dangerouslySetInnerHTML={{ __html: Text.InfoDay.Content[context.language] }} variant="body1" />
                <Stack sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box
                        component="img"
                        onClick={() => { window.open('https://www.pohtyh.edu.hk/Files/SchoolIntroDay/2024Publicity.pdf', '_blank') }}
                        src="https://www.pohtyh.edu.hk/Files/SchoolIntroDay/2024Publicity.jpg"
                        sx={{ cursor: 'pointer', height: '256px', mt: { xs: 0, sm: 2 }, objectFit: 'contain' }}
                    />
                    <Link
                        href="https://www.pohtyh.edu.hk/Files/SchoolIntroDay/2024Publicity.pdf"
                        rel="noopener"
                        sx={{ alignItems: 'center', display: 'flex' }}
                        target="_blank"
                    >
                        <ZoomIn />
                        {Text.InfoDay.Magazine[context.language]}
                    </Link>
                </Stack>*/}
            </Box>
            {/*<Paper sx={{ mt: 2, p: 2 }} variant="outlined">
                <ContentTitle sx={{ textAlign: 'center' }} text={Text.InfoDay.Form.Title[context.language]} />
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            error={!validation.parent}
                            focused
                            helperText={!validation.parent && Text.InfoDay.Form.Error.ParentName[context.language]}
                            label={Text.InfoDay.Form.ParentName[context.language]}
                            onBlur={handleBlurParent}
                            onChange={(e) => { setFormValue(preState => ({ ...preState, parent: e.target.value })) }}
                            required
                            sx={{ width: 1 }}
                            value={formValue.parent}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            error={!validation.student}
                            focused
                            helperText={!validation.student && Text.InfoDay.Form.Error.StudentName[context.language]}
                            label={Text.InfoDay.Form.StudentName[context.language]}
                            onBlur={handleBlurStudent}
                            onChange={(e) => { setFormValue(preState => ({ ...preState, student: e.target.value })) }}
                            required
                            sx={{ width: 1 }}
                            value={formValue.student}
                        />
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <Autocomplete
                            disablePortal
                            freeSolo
                            inputValue={formValue.school}
                            onInputChange={(e, newInputValue) => { setFormValue(preState => ({ ...preState, school: newInputValue ?? '' })) }}
                            onChange={(e, newValue) => { setFormValue(preState => ({ ...preState, school: newValue ?? '' })) }}
                            options={schoolList}
                            sx={{ width: 1 }}
                            renderInput={
                                (params) => <TextField {...params} focused label={Text.InfoDay.Form.PrimarySchool[context.language]} />
                            }
                            value={formValue.school}
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 4}}>
                        <TextField
                            error={!validation.attendees}
                            focused
                            helperText={!validation.attendees && Text.InfoDay.Form.Error.NoOfAttendees[context.language]}
                            InputProps={{ inputProps: { max: 3, min: 1 } }}
                            label={Text.InfoDay.Form.NoOfAttendees[context.language]}
                            onBlur={handleBlurAttendees}
                            onChange={(e) => { setFormValue(preState => ({ ...preState, attendees: parseInt(e.target.value) })) }}
                            required
                            sx={{ width: 1 }}
                            type="number"
                            value={formValue.attendees}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }}>
                        <TextField
                            error={!validation.phone}
                            focused
                            helperText={!validation.phone && Text.InfoDay.Form.Error.Phone[context.language]}
                            InputProps={{ inputProps: { max: 99999999, min: 10000000 } }}
                            label={Text.InfoDay.Form.Phone[context.language]}
                            onBlur={handleBlurPhone}
                            onChange={(e) => { setFormValue(preState => ({ ...preState, phone: parseInt(e.target.value) })) }}
                            sx={{ width: 1 }}
                            type="number"
                            value={formValue.phone}
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            error={!validation.email}
                            focused
                            helperText={!validation.email && Text.InfoDay.Form.Error.Email[context.language]}
                            label={Text.InfoDay.Form.Email[context.language]}
                            onBlur={handleBlurEmail}
                            onChange={(e) => { setFormValue(preState => ({ ...preState, email: e.target.value })) }}
                            placeholder={Text.InfoDay.Form.EmailNotice[context.language]}
                            required
                            sx={{ width: 1 }}
                            value={formValue.email}
                        />
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <TextField
                            focused
                            label={Text.InfoDay.Form.Message[context.language]}
                            multiline
                            onChange={(e) => { setFormValue(preState => ({ ...preState, enquiry: e.target.value })) }}
                            rows={5}
                            sx={{ width: 1 }}
                            value={formValue.enquiry}
                        />
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                            <Button disabled={disableRegister} onClick={handleClickRegister} variant="contained">
                                {Text.InfoDay.Form.Register[context.language]}
                            </Button>
                            {
                                disableRegister && !registered &&
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Alert severity="warning">{Text.InfoDay.Form.Error.CorrectForm[context.language]}</Alert>
                                </Box>
                            }
                        </Box>
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Alert severity="info">{Text.InfoDay.Form.Statement[context.language]}</Alert>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>*/}
            <Snackbar
                autoHideDuration={5000}
                onClose={() => { setShowSnackbar(preState => ({ ...preState, open: false })) }}
                open={showSnackbar.open}
            >
                <Alert
                    onClose={() => { setShowSnackbar(preState => ({ ...preState, open: false })) }}
                    severity={showSnackbar.severity}
                    variant="filled"
                    sx={{ width: 1 }}
                >
                    {showSnackbar.message}
                </Alert>
            </Snackbar>
        </BoxSubPage>
    );
};
export default InfoDay;